<template>
  <div>
    <v-hover>
      <v-img
        v-if="imageUrl"
        class="align-center text-center template-default-img"
        :src="imageUrl"
        height="190"
        cover
        position="center center">
      </v-img>
    </v-hover>
  </div>
</template>

<script>
import {mapMutations, mapGetters} from 'vuex'

export default {
  name: 'templateImage',
  props: {
    imageUrl: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  watch: {
  },
  destroyed () {
  },
  mounted () {
  },
  methods: {
    ...mapMutations([
    ])
  }
}
</script>

<style scoped>
.template-default-img {
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/line/item/templateImage.vue